import { SVGProps } from 'react';

export const CircleInfo = ({
  width = 24,
  height = 24,
  stroke = '#494949',
  ...otherProps
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    viewBox='0 0 20 20'
    {...otherProps}
  >
    <path
      d='M9.99918 6.66671C9.88418 6.66671 9.79085 6.76004 9.79168 6.87504C9.79168 6.99004 9.88501 7.08337 10 7.08337C10.115 7.08337 10.2083 6.99004 10.2083 6.87504C10.2083 6.76004 10.115 6.66671 9.99918 6.66671'
      stroke={stroke}
      stroke-width='1.3'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M10 10V14.1667M10 17.5C5.8575 17.5 2.5 14.1425 2.5 10C2.5 5.8575 5.8575 2.5 10 2.5C14.1425 2.5 17.5 5.8575 17.5 10C17.5 14.1425 14.1425 17.5 10 17.5Z'
      stroke={stroke}
      stroke-width='1.3'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);
